import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboard } from '../hooks';
import { useLanguage } from '../contexts';
import LanguageSelector from '../components/common/LanguageSelector';
import {
  DashboardHeader,
  WelcomeCard,
  AttemptsList,
  InstructionsModal,
} from '../components/dashboard';

const DashboardPage: React.FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const {
    attempts,
    remainingAttempts,
    loading,
    starting,
    showInstructions,
    setShowInstructions,
    handleStartTest,
    handleLogout,
  } = useDashboard();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral">
        <p className="text-gray-600">{t('common.loading')}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral p-4" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Language selector - fixed top-right corner */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageSelector />
      </div>

      <div className="max-w-xl mx-auto">
        <DashboardHeader onLogout={handleLogout} />
        <WelcomeCard
          remainingAttempts={remainingAttempts}
          onStartClick={() => setShowInstructions(true)}
        />
        <AttemptsList attempts={attempts} />
      </div>

      {showInstructions && (
        <InstructionsModal
          onClose={() => setShowInstructions(false)}
          onStart={(language) => {
            setShowInstructions(false);
            handleStartTest(language);
          }}
          starting={starting}
          attemptedLanguages={attempts.map(a => a.language)}
        />
      )}
    </div>
  );
};

export default DashboardPage;
